import { useAwardText } from './useAwardText';
import { useGiveableAwards } from './useGiveableAwards';

export const useAwardData = () => {
	const { awards, isLoading } = useGiveableAwards();
	const awardText = useAwardText(awards);

	return {
		awardText,
		isLoading,
		shouldDisplayBanner: !!awards.length,
	};
};
